export default "__VITE_ASSET__ca566fbe__"